// components/Layout/PageLayout.jsx
import React, { useState, useMemo } from 'react';
import clsx from 'clsx';
import { Dialog } from 'components/Elements';
import Breadcrumbs from './Breadcrumbs';

export const PageLayout = ({
  title,
  routes = [],
  sections = [],
  isLoading = false,
  loadingText = 'Loading…',
  commandBar = null,
}) => {
  const [activeId, setActiveId] = useState(null);
  const [open, setOpen] = useState(false);

  const activeSection = useMemo(
    () => sections.find((s) => s.id === activeId),
    [sections, activeId]
  );

  const openSection = (id) => {
    setActiveId(id);
    setOpen(true);
  };

  const closeDialog = () => setOpen(false);

  if (isLoading) {
    return <div className="p-6 text-center text-gray-500">{loadingText}</div>;
  }

  return (
    <>
      {/* Header */}
      <div className="mb-4">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        {routes.length > 0 && <Breadcrumbs routes={routes} />}
      </div>

      {/* Section List */}
      <div className="max-w-4xl mx-auto px-4 py-4 space-y-3">
        {sections.map((s) => (
          <button
            key={s.id}
            onClick={() => openSection(s.id)}
            className={clsx(
              'w-full text-left px-4 py-4 rounded-2xl border bg-white shadow-sm',
              'flex items-center justify-between',
              'hover:bg-gray-100 transition'
            )}
          >
            <div>
              <div className="text-sm font-medium text-gray-900">{s.title}</div>
              {s.desc && <div className="text-xs text-gray-500">{s.desc}</div>}
            </div>

            <div className="text-xs text-gray-400">Edit ›</div>
          </button>
        ))}
      </div>

      {/* Editor Dialog */}
      <Dialog isOpen={open} onClose={closeDialog} initialFocus={null}>
        <div className="inline-block align-bottom bg-white rounded-3xl text-left min-h-[70vh] overflow-hidden shadow-xl transform transition-all sm:align-middle w-full max-w-3xl">
          <div className="px-6 py-4 border-b flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{activeSection?.title}</h3>
              {activeSection?.desc && <p className="text-sm text-gray-500">{activeSection.desc}</p>}
            </div>

            <button
              onClick={closeDialog}
              className="px-3 py-2 rounded bg-gray-100 hover:bg-gray-200 text-sm"
            >
              Close
            </button>
          </div>

          <div className="px-6 py-6 overflow-auto">{activeSection?.component}</div>
        </div>
      </Dialog>

      {/* Optional Command Bar */}
      {commandBar}
    </>
  );
};
